import { gql } from '@apollo/client';

/**
 * Represents the OAuth provider object that can be reused in queries and
 * mutations as a response fragment.
 */
const oAuthProviderFragment = gql`
  fragment OAuthProviderFragment on Management_OAuthProvider {
    id
    strategy
    name
    organizationId
    settings {
      key
      value
    }
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
`;

/** Query to retrieve all available OAuth strategies. */
export const readOAuthProviderStrategiesQuery = gql`
  query readOAuthProviderStrategies {
    Management {
      oAuthProviderStrategies {
        name
        label
      }
    }
  }
`;

/** Query to retrieve the OAuth provider schema. */
export const readOAuthProviderConfigurationSchemaQuery = gql`
  query readOAuthProviderConfigurationSchema($id: String!) {
    Management {
      oAuthProviderConfigurationSchema(strategy: $id) {
        key
        label
        required
        secret
        type
        defaultValue
      }
    }
  }
`;

/** Query to retrieve OAuth providers. */
export const readOAuthProvidersQuery = gql`
  ${oAuthProviderFragment}

  query readOAuthProviders($id: ID) {
    Management {
      oAuthProviders(id: $id) {
        ...OAuthProviderFragment
      }
    }
  }
`;

/** Mutation to create an OAuth provider. */
export const createOAuthProviderMutation = gql`
  ${oAuthProviderFragment}

  mutation createOAuthProvider(
    $strategy: String!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createOAuthProvider(
        strategy: $strategy
        name: $name
        settings: $settings
      ) {
        ...OAuthProviderFragment
      }
    }
  }
`;

/** Mutation to update an OAuth provider. */
export const updateOAuthProviderMutation = gql`
  ${oAuthProviderFragment}

  mutation updateOAuthProvider(
    $id: ID!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      updateOAuthProvider(id: $id, name: $name, settings: $settings) {
        ...OAuthProviderFragment
      }
    }
  }
`;

/** Mutation to delete an OAuth provider. */
export const deleteOAuthProviderMutation = gql`
  ${oAuthProviderFragment}

  mutation deleteOAuthProvider($id: ID!) {
    Management {
      deleteOAuthProvider(id: $id) {
        ...OAuthProviderFragment
      }
    }
  }
`;
